import axios from "axios"
import { makeAxiosGraphQLFetcher } from "./fetcher"

const fetcher = makeAxiosGraphQLFetcher({
	url: () => window.envConfig?.COVERGO_GRAPHQL,
	axios,
	debug: true
})

export default fetcher
